import { BronzeConsistencyIncentiveSection } from '@sections/BronzeConsistencyIncentiveSection'
import { BronzeIncentivesSection } from '@sections/BronzeIncentivesSection'
import { BusinessSection } from '@sections/BusinessSection'
import { DepthSection } from '@sections/DepthSection'
import { FrontlinesSection } from '@sections/FrontlinesSection'
import { LeadershipPlusIncentiveSection } from '@sections/LeadershipPlusIncentiveSection'
import { PathToBronzeSection } from '@sections/PathToBronzeSection'
import { PerformancePlusSection } from '@sections/PerformancePlusSection'
import { SectionComponentClass, SectionKey } from '@sections/SectionComponent'
import { TwoTimeCashIncentiveSection } from '@sections/TwoTimeCashIncentiveSection'

// SimulatorPage resolves sections positionally by SectionKey value (usage
// tracking, collapse keys, drawer navigation), so this list MUST stay aligned
// with the SectionKey enum. The pairs below make each entry's intended key
// explicit and the module-load assertion turns silent drift into a loud error.
const sections: [SectionKey, SectionComponentClass][] = [
  [SectionKey.BUSINESS, BusinessSection],
  [SectionKey.FRONTLINES, FrontlinesSection],
  [SectionKey.DEPTH, DepthSection],
  [SectionKey.PATH_TO_BRONZE, PathToBronzeSection],
  [SectionKey.BRONZE_INCENTIVES, BronzeIncentivesSection],
  [SectionKey.BRONZE_CONSISTENCY_INCENTIVES, BronzeConsistencyIncentiveSection],
  [SectionKey.PERFORMANCE_PLUS, PerformancePlusSection],
  [SectionKey.LEADERSHIP_PLUS_INCENTIVE, LeadershipPlusIncentiveSection],
  [SectionKey.TWO_TIME_CASH_INCENTIVE, TwoTimeCashIncentiveSection]
]

sections.forEach(([key], index) => {
  if (key !== index) {
    throw new Error(`Section list order broken at index ${index}, expected SectionKey value ${index} but found ${key}`)
  }
})

export function simulatorPageSection(): SectionComponentClass[] {
  return sections.map(([, component]) => component)
}
